export default {
    color: 'text.primary',
    width: '100%',
    display: 'block',
};
